// extracted by mini-css-extract-plugin
export var active = "_34-9";
export var backButton = "_34-8";
export var clone = "_34-e";
export var collapseBar = "_34-j";
export var collapseMode = "_34-l";
export var collapsed = "_34-n";
export var dragHandle = "_34-c";
export var dropdownIcon = "_34-g";
export var expanding = "_34-m";
export var hidden = "_34-w";
export var iconContainer = "_34-p";
export var iconSwapper = "_34-v";
export var navItem = "_34-6";
export var navItemIcon = "_34-f";
export var navProfile = "_34-7";
export var notificationCountBadge = "_34-i";
export var notificationDot = "_34-q";
export var optionsContainer = "_34-h";
export var primaryNav = "_34-0";
export var primaryNavDivider = "_34-u";
export var primaryNavResizeHandle = "_34-2";
export var primaryNavResizing = "_34-1";
export var primaryNavTabSection = "_34-t";
export var primaryTab = "_34-o";
export var primaryTabIconBox = "_34-r";
export var secondaryNav = "_34-3";
export var selected = "_34-s";
export var settingsNav = "_34-4";
export var settingsNavItems = "_34-5";
export var show = "_34-d";
export var sideNav = "_34-k";
export var teamItem = "_34-a";
export var userProfileItem = "_34-b";